import Icon from '@components/atoms/icon';

type MobileToolTabProps = {
  icon: string;
  title: string;
  subtitle: string;
  onClick: () => void;
};

const MobileToolTab = ({
  icon,
  title,
  subtitle,
  onClick
}: MobileToolTabProps) => (
  <button
    type="button"
    onClick={onClick}
    className="flex h-full w-full flex-col rounded-[12px] border border-neutral-200 bg-white p-3.5 text-left shadow-sm transition-colors active:bg-neutral-100"
  >
    <div className="flex w-full items-center justify-between">
      <span
        aria-hidden="true"
        className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-50 text-lg"
      >
        {icon}
      </span>
      <Icon name="ArrowRight" className="h-4 w-4 text-neutral-500" />
    </div>
    <span className="mt-3 font-sans text-[15px] font-semibold leading-5 text-neutral-800">
      {title}
    </span>
    <span className="mt-0.5 font-open-sans text-xs leading-4 text-neutral-600">
      {subtitle}
    </span>
  </button>
);

export default MobileToolTab;
